import { Backdrop, Fade, Grid, Box, IconButton, Menu, MenuItem, Modal, Tooltip, Typography } from '@material-ui/core';
import { MoreHoriz as MoreHorizIcon, GridOn as TableChartIcon, Close as CloseIcon } from '@material-ui/icons';
import { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import QCXPopupState from '../../../../../components/popup-state/QCXPopupState';
import { changeToConsultMode } from '../../../../../features/follow-up/followUpSlice';
import QCXListItemIcon from '../../../../../shared-components/list-item-icon/QCXListItemIcon';
import DataGridControl from '../../../../../templates/simple-consult-page/SimpleConsultPageTemplate/DataGridControl';
import FollowUpStatusUtils from '../../../../../utils/general/follow-up/FollowUpStatusUtils';
import { formatDate } from '../../../../../utils/general/general-utils';
import { formatCnpj } from '../../../../../utils/hooks/form/field/formatters';
import FollowUpListManagerPage from '../../follow-up/FollowUpListManagerPage/FollowUpListManagerPage';

export default function GestaoAVistaFollowUpList({
  processos = [],
  processosCount = 0,
  pageSize = 0,
  loading = false,
  onConfigChangeCallback = () => {},
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [selectedFollowUpId, setSelectedFollowUpId] = useState(null);

  const isModalOpen = !!selectedFollowUpId;

  const closeModal = () => setSelectedFollowUpId(null);

  const handleConsultarListClick = (id) => {
    dispatch(changeToConsultMode());
    setSelectedFollowUpId(id);
  };

  const rowHeight = 38;
  const gridHeight = pageSize * rowHeight + 200;

  const columns = [
    {
      field: 'numero',
      headerName: t('com.muralis.qcx.processo'),
      flex: 1,
      valueGetter: ({ row }) => row?.numero || '-',
    },
    {
      field: 'referencia',
      headerName: t('com.muralis.qcx.referencia'),
      flex: 1,
      valueGetter: ({ row }) => row?.referenciaCliente || '-',
    },
    {
      field: 'importador',
      headerName: t('com.muralis.qcx.importador.label'),
      flex: 1,
      valueGetter: ({ row }) => row?.importadorNome || '-',
    },
    {
      field: 'cliente',
      headerName: t('com.muralis.qcx.cliente.label'),
      flex: 1,
      valueGetter: ({ row }) => row?.clienteNome || '-',
    },
    {
      field: 'importador.cnpj',
      headerName: t('com.muralis.qcx.empresa.CNPJ'),
      flex: 1,
      valueGetter: ({ row }) => formatCnpj(row?.cnpj) || '-',
    },
    {
      field: 'servico',
      headerName: t('com.muralis.qcx.servico.labelSingular'),
      flex: 1,
      valueGetter: ({ row }) => row?.servicoNome || '-',
    },
    {
      field: 'insertionDate',
      headerName: t('com.muralis.qcx.abertura'),
      headerAlign: 'center',
      align: 'center',
      type: 'date',
      flex: 1,
      valueGetter: ({ row }) => formatDate(row?.abertura, "YYYY-MM-DD'T'HH:mm:ss", 'DD/MM/YYYY') || '-',
    },
    {
      field: 'status',
      headerName: t('com.muralis.qcx.status'),
      flex: 1,
      valueGetter: ({ row }) =>
        FollowUpStatusUtils.getLabelByValue(row?.status) ? t(FollowUpStatusUtils.getLabelByValue(row?.status)) : '-',
    },
    {
      field: 'actions',
      headerName: t('com.muralis.qcx.acoes.label'),
      headerAlign: 'center',
      align: 'center',
      width: 120,
      renderCell: ({ row }) => (
        <QCXPopupState popupId="popup-menu-gestao-a-vista">
          {(popupState) => (
            <>
              <Tooltip title={t('com.muralis.qcx.maisOpcoes')} arrow>
                <IconButton
                  key={`btn-more-options-gestao-a-vista-${row?.id}`}
                  name={`btn-more-options-gestao-a-vista-${row?.id}`}
                  {...bindTrigger(popupState)}
                >
                  <MoreHorizIcon color="secondary" size={20} />
                </IconButton>
              </Tooltip>
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  onClick={(event) => {
                    popupState.close(event);

                    handleConsultarListClick(row?.id);
                  }}
                >
                  <QCXListItemIcon>
                    <TableChartIcon color="secondary" />
                  </QCXListItemIcon>
                  <Typography
                    variant="inherit"
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {'Visualizar Lista'.toUpperCase()}
                  </Typography>
                </MenuItem>
              </Menu>
            </>
          )}
        </QCXPopupState>
      ),
    },
  ];

  return (
    <Grid container xs={12} style={{ marginTop: 32 }}>
      <Box style={{ width: '100%', height: gridHeight }}>
        <DataGridControl
          onConfigChangeCallback={onConfigChangeCallback}
          columns={columns}
          rows={processos}
          rowsCount={processosCount}
          loading={loading}
        />
      </Box>

      <Modal
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        open={isModalOpen}
        onClose={closeModal}
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={isModalOpen}>
          <div
            style={{
              width: '90%',
              height: '90%',
              overflowY: 'scroll',
              backgroundColor: 'white',
              borderRadius: 16,
              padding: 32,
              position: 'relative',
            }}
          >
            <IconButton
              aria-label="close"
              onClick={closeModal}
              style={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'grey',
              }}
            >
              <CloseIcon />
            </IconButton>
            <FollowUpListManagerPage id={String(selectedFollowUpId)} noLayout />
          </div>
        </Fade>
      </Modal>
    </Grid>
  );
}
